import { Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Product } from '@shared/models/product.model';
import { ProductSku } from '@shared/models/product-sku.model';
import { SubmitCartItem } from '@shared/models/submit-cart-item.model';
import { CartService } from '@shared/services/cart.service';
import { CommonService } from '@shared/services/common.service';
import { LocaleService } from '@shared/services/locale.service';

const NAME_SPLIT_RE = /^(.+?)\s+([A-Za-z].*)$/;

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
  @Input() product!: Product;

  quantity = 1;

  constructor(
    private snackBar: MatSnackBar,
    private cartService: CartService,
    private commonService: CommonService,
    private locale: LocaleService
  ) {}

  get sku(): ProductSku {
    return this.product?.productSkus?.[0];
  }

  get nameParts(): { zh: string; en: string } {
    const raw = (this.sku?.productSkuEavs || []).find((e: any) => e.attribute === 'name')?.value || '';
    const m = raw.match(NAME_SPLIT_RE);
    return m ? { zh: m[1].trim(), en: m[2].trim() } : { zh: raw, en: '' };
  }

  get displayName(): string {
    const parts = this.nameParts;
    if (!parts.en) return parts.zh;
    return this.locale.isEn ? parts.en : parts.zh;
  }

  get displaySubName(): string {
    const parts = this.nameParts;
    if (!parts.en) return '';
    return this.locale.isEn ? parts.zh : parts.en;
  }

  get badge(): string | null {
    const eav = this.sku?.productSkuEavs?.find((e: any) => e.attribute === 'featured');
    return eav?.value === 'true' ? $localize`:@@product.badge.bestSeller:Best Seller` : null;
  }

  isOutOfStock(): boolean {
    return this.sku && this.sku.stock <= this.sku.minStockLevel;
  }

  isSalesPrice(): boolean {
    const sku = this.sku;
    if (sku?.salesFrom && sku?.salesTo && sku?.salesPrice) {
      const today = new Date().getTime() / 1000;
      return today > sku.salesFrom && today < sku.salesTo;
    }
    return false;
  }

  incrementQty(): void {
    this.quantity += 1;
  }

  decrementQty(): void {
    if (this.quantity > 1) this.quantity -= 1;
  }

  openPopup(): void {
    if (!this.sku) return;
    this.commonService.setProduct(this.sku);
    this.commonService.openProductPopup();
  }

  addToCart(): void {
    if (!this.sku || this.isOutOfStock()) return;

    const item = new SubmitCartItem();
    item.setproductSku(this.sku.id.toString());
    item.setquantity(this.quantity.toString());

    try {
      this.cartService.addToCart(item).subscribe(cart => {
        this.cartService.setCart(cart);
        this.snackBar.open($localize`:@@cart.snackbar.added:已加入購物籃`, null, { duration: 2000 });
      });
    } catch (e) {
      console.error('addToCart failed', e);
    }
  }
}
